import type { SVGProps } from "react";

export function ENSDbIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M2.86523 0.716797H17.1348C18.3216 0.716804 19.2832 1.67842 19.2832 2.86523V17.1348C19.2832 18.3216 18.3216 19.2832 17.1348 19.2832H2.86523C1.67842 19.2832 0.716804 18.3216 0.716797 17.1348V2.86523C0.716804 1.67842 1.67842 0.716804 2.86523 0.716797Z"
        fill="url(#paint0_radial_1266_5360)"
        stroke="black"
        strokeWidth="1.43262"
      />
      <ellipse cx="9.99893" cy="6.04007" rx="5.28018" ry="2.04007" fill="#500C9E" />
      <path
        d="M15.2842 8.80005H15.2744C15.1135 9.8708 12.8156 10.7199 10.0039 10.72C7.19219 10.72 4.89443 9.8708 4.7334 8.80005H4.72363V7.35962C5.41691 8.19351 7.51726 8.80005 10.001 8.80005C12.4924 8.79998 14.5977 8.18974 15.2842 7.35181V8.80005Z"
        fill="#500C9E"
      />
      <path
        d="M15.2842 11.4395H15.2744C15.1136 12.5102 12.8156 13.3593 10.0039 13.3594C7.19209 13.3594 4.89428 12.5103 4.7334 11.4395H4.72363V10C5.41733 10.8336 7.51775 11.4395 10.001 11.4395C12.4919 11.4394 14.5973 10.8299 15.2842 9.99219V11.4395Z"
        fill="#500C9E"
      />
      <path
        d="M15.2842 14.0801H15.2744C15.1136 15.1509 12.8156 15.9999 10.0039 16C7.1921 16 4.8943 15.1509 4.7334 14.0801H4.72363V12.6406C5.41736 13.4742 7.51778 14.0801 10.001 14.0801C12.4919 14.08 14.5973 13.4705 15.2842 12.6328V14.0801Z"
        fill="#500C9E"
      />
      <defs>
        <radialGradient
          id="paint0_radial_1266_5360"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10 10) rotate(90) scale(10)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#C999FF" />
        </radialGradient>
      </defs>
    </svg>
  );
}
